import { FC, memo } from "react";
import { Section } from "./Section";
import { SiteAccessList } from "./SiteAccessList";
import { ViewProps } from "react-native";

type SiteAccessSectionProps = {
  title: string;
  style?: ViewProps["style"];
  subtitle?: string;
};

export const SiteAccessSection: FC<SiteAccessSectionProps> = memo(({ title, style, subtitle }) => {
  return (
    <Section title={title} style={style} subtitle={subtitle}>
      <SiteAccessList />
    </Section>
  );
});
